import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "LazyLnLChunk" */ './LaunchNLearnConnect'),
    {
        fallback: <div>Loading...</div>,
    }
);
